import { parseDateOnly } from '@/helpers/dateHelper';
import type { ReadLeaveRequestPeriodCheck } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { format } from 'date-fns';

export interface PeriodLabelMessages {
  thisYear: string;
}

export const periodLabel = (c: ReadLeaveRequestPeriodCheck) => {
  const start = parseDateOnly(c.periodStart);
  const end = parseDateOnly(c.periodEnd);
  const now = new Date();

  if (now >= start && now <= end) return strings.common.thisYear.toLowerCase();
  if (start.getMonth() === 0) return String(start.getFullYear());

  return `${format(start, 'MMM yyyy')} to ${format(end, 'MMM yyyy')}`;
};
